import { Paper, Box, Typography } from '@mui/material';
import { ReactNode } from 'react';
import { tokens } from './tokens';

interface Props {
  title?: ReactNode;
  action?: ReactNode;
  children?: ReactNode;
  bodyPadding?: number | string;
  noBodyPadding?: boolean;
  sx?: any;
}

export function Card({ title, action, children, bodyPadding = '12px', noBodyPadding, sx }: Props) {
  return (
    <Paper
      elevation={0}
      sx={[
        {
          borderRadius: `${tokens.radius}px`,
          background: tokens.surface,
          boxShadow: tokens.shadowSm,
        },
        ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
      ]}>
      {(title || action) && (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: { xs: '14px 16px', sm: '16px 24px' },
            borderBottom: `1px solid ${tokens.divider}`,
          }}>
          {typeof title === 'string' ? (
            <Typography sx={{ fontSize: 16, fontWeight: 500, color: tokens.text }}>{title}</Typography>
          ) : (
            title
          )}
          {action}
        </Box>
      )}
      <Box sx={{ padding: noBodyPadding ? 0 : bodyPadding }}>{children}</Box>
    </Paper>
  );
}
